import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';
import { ImageComponent } from '@zaoblako/web/shared/dumbs/image/image.component';
import { FileUrlPipe } from '@zaoblako/web/shared/pipes/file-url.pipe';
import { ApiUrlPipe } from '@zaoblako/web/shared/pipes/api-url.pipe';
import { FileTypePipe } from '@zaoblako/web/shared/pipes/file-type.pipe';

@Component({
  standalone: true,
  selector: 'crm-file',
  templateUrl: './file.component.html',
  imports: [CommonModule, FileUrlPipe, ApiUrlPipe, FileTypePipe, ImageComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileComponent {
  @Input() public file: FileFindInterface;

  @Input() public canDelete = false;
  @Output() public delete = new EventEmitter();
}
